import { navigateWithConditionalReplace } from '../../utils/navigationUtils';
import { NIL_UUID } from '../constants/index';
import { ProfileType } from '../types';

export function isExpired(expiresAt: ProfileType['expiresAt']) {
  const now = Date.now();
  return expiresAt && new Date(expiresAt).getTime() < now;
}

export function handleProfileExpired(email?: string, loginUrl?: string) {
  navigateWithConditionalReplace(
    `${loginUrl ?? '/login'}?authuser=${encodeURIComponent(NIL_UUID)}&${
      email ? `email=${encodeURIComponent(email)}&` : ''
    }action=switch_account&expired=true`,
  );
}
